<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span v-if="this.datosRegistro.id==null">Registrar Nuevo Cliente</span>
            <span v-else>Editar Cliente</span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row">
      <div class="col-4">
        <span class="text">Cliente:</span>
        <input v-model="datosRegistro.cliente" class="m-4" type="text" placeholder="Cliente">
      </div>
    </div>
    <div class="row">
      <div class="col" align="center">
        <button class="btn btn-success " @click="registrar()">Guardar</button>
      </div>
      <div class="col" align="center">
        <button class="btn btn-danger " @click="cancelar()">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {ClienteService} from "@/services/ClienteService";

export default {
  components: {},

  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_clienteService: new ClienteService(inject('$axios'))
    }
  },
  props: {
    original: Object
  },
  data() {
    return {
      datosRegistro: {
        id: null,
        nombre: null
      },
    }
  },
  mounted() {
    if (this.original != null && this.original.id != null) {
      this.obtener();
    }
  },
  methods: {
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_clienteService.obtener({nombre: ""+this.original.id}).then((response) => {
        if (response != null && response.length > 0) {
          this.datosRegistro = response[0];
        }
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async registrar() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_clienteService.cargar(this.datosRegistro).then((res) => {
        this.$swal(res.msj);
        this.cancelar();
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    }
  }
}
</script>

<style scoped>

</style>